import { styled } from 'stitches.config'

export const ImageWithTextRoot = styled('div', {
  width: '100%',
  variants: {
    background: {
      tertiary: {
        backgroundColor: '$tertiary-200',
      },
      secondary: {
        backgroundColor: '$secondary-500',
      },
      white: {
        backgroundColor: '$accent-white',
      },
      primary: {
        backgroundColor: '$primary-700',
      },
    },
  },
})

export const CopyColumn = styled('div', {
  flex: '1 1 100%',
  display: 'flex',

  '@bp2': {
    flex: '1 1 50%',
  },
})

export const ImageColumn = styled('div', {
  flex: '1 1 100%',

  '@bp2': {
    flex: '1 1 50%',
  },
})

export const FlexBox = styled('div', {
  padding: '0px 16px',
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  gap: '32px',

  '@bp2': {
    maxWidth: '1440px',
    padding: '0px 74px',
    flexDirection: 'row',
    alignItems: 'center',
  },

  variants: {
    imageSide: {
      left: {
        '@bp2': {
          '& div.image-col': {
            order: 0,
          },
          '& div.copy-col': {
            order: 1,
          },
        },
      },
      right: {
        '@bp2': {
          '& div.image-col': {
            order: 1,
          },
          '& div.copy-col': {
            order: 0,
          },
        },
      },
    },

    isMobileImageBottom: {
      true: {
        '& .image-col': {
          order: 1,
        },
        '& .copy-col': {
          order: 0,
        },
      },
      false: {},
    },
  },
})
